import { Typography } from '@cleartrip/ct-design-components'
import React from 'react'

interface FilterJourneyInfoProps {
  from: string
  to: string
  isRT: boolean
  isRevamp?: boolean
  /** Legacy heading styles differed per filter; callers pass their original ones. */
  legacyVariant?: 'B2' | 'L2'
  legacyClassName?: string
}

const FilterJourneyInfo = ({
  from,
  to,
  isRT,
  isRevamp = false,
  legacyVariant = 'B2',
  legacyClassName = 'c-pointer mb-3',
}: FilterJourneyInfoProps) => {
  if (!isRT) return null
  if (isRevamp) {
    return (
      <Typography className='mb-1' color='subheading' variant='P3'>
        {`${from} → ${to}`}
      </Typography>
    )
  }

  return (
    <Typography className={legacyClassName} variant={legacyVariant}>
      {`${from} -> ${to}`}
    </Typography>
  )
}

export default FilterJourneyInfo
